import { render, staticRenderFns } from "./PurchaseOrderListDisplay.vue?vue&type=template&id=27a7609a&scoped=true"
import script from "./PurchaseOrderListDisplay.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderListDisplay.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderListDisplay.vue?vue&type=style&index=0&id=27a7609a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7609a",
  null
  
)

export default component.exports